export default {
    activity1011Config: {
        title: '1011 Task Config',
        saveSection: 'Save Section',
        reload: 'Reload',
        pageDesc:
            'Read/write configs key=activity: time, tasks, check-in points, spread bonus and leaderboard rewards. Each section saves independently.',
        configExists: 'exists, will update',
        configNew: 'not created yet, will create on save',
        sections: {
            basic: 'Basics',
            time: 'Activity Time',
            tasks: 'Tasks',
            checkin: 'Check-in Points',
            spread: 'Spread Bonus',
            rewards: 'Leaderboard Rewards',
        },
        fields: {
            title: 'Title',
            status: 'Status',
            activityId: 'Activity ID',
            timeRange: 'Activity period',
            points: 'Points',
            threshold: 'Threshold',
            checkinDay: 'Day {day}',
            typePlaceholder: 'Select task type',
            ruleTitle: 'Rule {index}: every {threshold} {metric}',
            ruleEvery: 'Every',
            ruleTimes: 'times',
            rulePoints: 'pts',
        },
        status: {
            enabled: 'Enabled',
            disabled: 'Disabled',
        },
        platforms: {
            x: 'X (Twitter)',
            tiktok: 'TikTok',
            youtube: 'YouTube',
            other: 'Other',
        },
        metrics: {
            play: 'Play',
            like: 'Like',
            retweet: 'Retweet',
        },
        columns: {
            taskId: 'ID',
            type: 'Type',
            description: 'Task name',
            points: 'Points',
            linkUrl: 'Link',
            minRank: 'Rank min',
            maxRank: 'Rank max',
            amount: 'Reward amount',
            action: 'Actions',
        },
        actions: {
            addTask: 'Add task',
            addTier: 'Add tier',
        },
        empty: {
            tasks: 'No tasks yet',
            rewards: 'No reward tiers yet',
        },
        load: {
            failed: 'Failed to load config',
        },
        save: {
            success: 'Config saved',
            failed: 'Save failed',
            conflict: 'Config was updated by someone else. Reloaded — review and save again.',
        },
    },
};
